import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenSpinner } from "../components/exports";

export default function Impersonate() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.clear();
        navigate("/");
    }, []);

    return <FullScreenSpinner />;
}
